import { Image } from 'antd';
import useCompany from "./useCompany";
import './CompanyBrand.css'; // Import the fine-tuning styles

const CompanyBrand = () => {
    const { logoUrl } = useCompany();

    return (
        <div className="company-brand-container">
            <Image
                src={logoUrl}
                preview={false}
                alt="Company Logo"
                style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain"
                }}
            />
        </div>
    );
};

export default CompanyBrand;
